import "./draggedUpload.css.ts.vanilla.mjs";
var a = "p273__draggedUpload-28c2_fc12ae487__1xoddaz1", _ = "p273__draggedUpload-28c2_fc12ae487__1xoddaz3", e = "p273__draggedUpload-28c2_fc12ae487__1xoddaz2", g = "p273__draggedUpload-28c2_fc12ae487__1xoddaz0";
export {
  a as darkTheme,
  _ as draggedUploadListStyle,
  e as draggedUploadStyle,
  g as lightTheme
};
//# sourceMappingURL=draggedUpload.mjs.map
